import React from "react";

// Mention à placer en fin d'un lien target="_blank" (RGAA 13.2), comme le fragment Thymeleaf fragments/nouvelle-fenetre.
// Pour un lien nommé par aria-label, ajouter « (nouvelle fenêtre) » à la fin de l'aria-label à la place.
export const NouvelleFenetre = () => <span className="sr-only"> (nouvelle fenêtre)</span>;

// Même mention, pour les contenus HTML injectés en chaîne (dangerouslySetInnerHTML)
export const NOUVELLE_FENETRE_HTML = '<span class="sr-only"> (nouvelle fenêtre)</span>';
